import React from 'react';
import { BarcodeLoader } from './ApeIcons';

export class ErrorBoundary extends React.Component {
	constructor(props) {
		super(props);
		this.state = { error: null };
	}

	static getDerivedStateFromError(error) {
		return { error };
	}

	componentDidCatch(error, info) {
		console.error('[ErrorBoundary]', this.props.name || 'unknown', error, info.componentStack);
	}

	render() {
		if (this.state.error) {
			if (this.props.fallback) return this.props.fallback;

			return (
				<div style={{
					margin: this.props.inline ? '0' : '24px',
					padding: this.props.inline ? '20px' : '48px 24px',
					borderRadius: '14px',
					border: '2px solid var(--line)',
					background: 'var(--card)',
					textAlign: 'center',
				}}>
					<div style={{
						fontFamily: 'var(--font-display)', fontSize: '22px', fontWeight: 800,
						color: 'var(--ink)', marginBottom: '8px',
					}}>
						Something went wrong
					</div>
					<p style={{
						fontFamily: 'var(--font-sans)', fontSize: '14px',
						color: 'var(--mut2)', margin: '0 0 16px', maxWidth: '400px', marginInline: 'auto',
					}}>
						{this.state.error.message || 'An unexpected error occurred in this section.'}
					</p>
					<button
						onClick={() => this.setState({ error: null })}
						style={{
							fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: '15px',
							letterSpacing: '0.5px', color: 'var(--color-carbon)', background: 'var(--accent)',
							border: '2px solid var(--bd)', borderRadius: '9px',
							padding: '8px 24px', cursor: 'pointer',
							boxShadow: '0 3px 0 rgba(17,17,17,.7)',
							transition: 'transform 100ms, box-shadow 100ms',
						}}
						onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(1px)'; e.currentTarget.style.boxShadow = '0 2px 0 rgba(17,17,17,.7)'; }}
						onMouseLeave={(e) => { e.currentTarget.style.transform = 'none'; e.currentTarget.style.boxShadow = '0 3px 0 rgba(17,17,17,.7)'; }}
					>
						TRY AGAIN
					</button>
				</div>
			);
		}

		return this.props.children;
	}
}

export const PageErrorBoundary = ({ children, name }) => (
	<ErrorBoundary name={name}>
		{children}
	</ErrorBoundary>
);

export const InlineErrorBoundary = ({ children, name }) => (
	<ErrorBoundary name={name} inline>
		{children}
	</ErrorBoundary>
);
